import React, { useEffect, useState } from 'react';
import { INavLink, INavLinkGroup, INavStyles, IRenderFunction, Nav, Text } from '@fluentui/react';
import pecmailService from '../../services/pecmail.service';

import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { matchPath, NavLinkProps, RouteComponentProps, withRouter } from 'react-router-dom';
import { IFolderPecMail, IMailbox, IMailboxInUor } from '../../shared/interfaces';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { useBoolean } from '@fluentui/react-hooks';
import { TipologiaCartella } from '../../shared/enums';



const navSyles: Partial<INavStyles> = {
    chevronButton: {
        selectors: {
            ':after': {
                border: 'none'
            }
        }

    }
}
const queryString = require('query-string');

const folderTreePathString = "/:aooId/pecmail/:mailboxAddress";
const mailListItemsPathString = "/:aooId/pecmail/:mailboxAddress/:folderId";
const mailItemViewerPathString = "/:aooId/pecmail/:mailboxAddress/:folderId/:mailId";


export interface PecMailFoldersTreeProps {
    onSelectFolder : (folderId) => void
}
type Props = PecMailFoldersTreeProps & RouteComponentProps



const PecMailFoldersTree: React.FunctionComponent<Props> = props => {


    const [loading, { setTrue: showLoader, setFalse: hideLoader }] = useBoolean(true);
    const [foldersNavLink, setFoldersNavLink] = useState<INavLink[]>([]);


    const [selectedAooId, setSelectedAooId] = useState<string | undefined>();
    const [selectedMailboxAddress, setSelectedMailboxAddress] = useState<string | undefined>();
    const [selectedFolderId, setSelectedFolderId] = useState<string | undefined>();
    const [selectedMailId, setSelectedMailId] = useState<string | undefined>();

    let sidebarMenuLinkGroups: INavLinkGroup[] = [{
        links: foldersNavLink
    }];

    useEffect(() => {

        getParamsValuesFromUrl();


    }, [props.location.pathname]);

    useEffect(() => {

        getAllFolders();


    }, [selectedMailboxAddress]);

    const getParamsValuesFromUrl = () => {
        const { location } = props;

        // Uso matchPath per prendere i parametri dai path dei component figli

        const matchFolderTreePath = matchPath(location.pathname, {
            path: folderTreePathString,
            exact: true
        })
        if (matchFolderTreePath) {
            setSelectedAooId(matchFolderTreePath.params['aooId']);
            setSelectedMailboxAddress(matchFolderTreePath.params['mailboxAddress']);

        }


        const matchMailListItemsPath = matchPath(location.pathname, {
            path: mailListItemsPathString,
            exact: true
        })
        if (matchMailListItemsPath) {
            setSelectedAooId(matchMailListItemsPath.params['aooId']);
            setSelectedMailboxAddress(matchMailListItemsPath.params['mailboxAddress']);
            let folderId = matchMailListItemsPath.params['folderId'];
            setSelectedFolderId(folderId);
            props.onSelectFolder(folderId);
        }



        const matchMailItemViewerPathString = matchPath(location.pathname, {
            path: mailItemViewerPathString,
            exact: true
        })
        if (matchMailItemViewerPathString) {
            setSelectedAooId(matchMailItemViewerPathString.params['aooId']);
            setSelectedMailboxAddress(matchMailItemViewerPathString.params['mailboxAddress']);
            let folderId = matchMailItemViewerPathString.params['folderId'];
            setSelectedFolderId(folderId);
            props.onSelectFolder(folderId);
            setSelectedMailId(matchMailItemViewerPathString.params['mailId']);
        }
    }

    const getAllFolders = () => {
        showLoader();
        const { location } = props;
        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        if (selectedAooId && uorId && selectedMailboxAddress) {
            setFoldersNavLink([]);
            pecmailService.getAllFolders(selectedAooId, uorId, selectedMailboxAddress)
                .then(foldersTree => {
                    let filteredFolders = foldersTree.filter(el => el.tipologia !== TipologiaCartella.Cestino && el.tipologia !== TipologiaCartella.Bozze && el.tipologia !== TipologiaCartella.PostaInUscita);
                    /// Rimappo le folders nel formato INavLink di fluent ui
                    /// e creo l'array foldersFlat che utilizzo per facilitare la ricerca di una cartella
                    let folders = remapFoldersInNavLinkArray(filteredFolders);
                    setFoldersNavLink(folders);


                    const matchMailListItemsPath = matchPath(location.pathname, {
                        path: mailListItemsPathString,
                        exact: true
                    })
                    const matchMailItemViewerPathString = matchPath(location.pathname, {
                        path: mailItemViewerPathString,
                        exact: true
                    })

                    if (!matchMailListItemsPath && !matchMailItemViewerPathString && folders.length > 0) {
                        selectFolder(null, folders[0])
                    }

                })
                .catch(error => { })
                .finally(() => hideLoader());
        }
    }


    const remapFoldersInNavLinkArray = (folders: IFolderPecMail[]): INavLink[] => {
        let result = folders.map(folderItem => {

            let children = remapFoldersInNavLinkArray(folderItem.children);
            let folderItemNome = folderItem.nome.length > 65 ? folderItem.nome.substring(0, 65) + '...' : folderItem.nome;
            let navLink: INavLink = { ...folderItem, key: folderItem.id.toString(), name: folderItemNome, url: '', links: children, isExpanded: true, onClick: (ev, item) => selectFolder(ev, item) }
            return navLink

        });
        return result;
    }

    const selectFolder = (ev, item) => {

        ev?.stopPropagation();
        ev?.preventDefault();


        let path = `/${selectedAooId}/pecmail/${selectedMailboxAddress}/${item.id}`;

        props.history.push({ pathname: path, search: props.location.search });


    }
    return (
        <div className={`position-relative flex flex-column`}>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <Text variant={'large'} block styles={{ root: { padding: '15px 25px 15px 15px' } }}>
                Cartelle
            </Text>
            <div className={`position-relative my-scroll-div`}>

                <Nav
                    groups={sidebarMenuLinkGroups}
                    selectedKey={selectedFolderId}
                    styles={navSyles}
                />

            </div>
        </div>
    );

}
export default withRouter(PecMailFoldersTree);

